import React from 'react';
//import selfi from "./images/DSC09792.JPG";

import TimeLine from "./components/TimeLine";



const Bio = () => {
  return (
    <div className='Bio'>
      <div className="Born">
        <h3 >born n stuff</h3>
      </div>
      <TimeLine />
    </div>
  )
};

export default Bio


